import React from 'react';
import { SalesPage } from './pages/SalesPage';
type AppProps = {
  /** Minutos del reloj de cuenta regresiva de la oferta */
  offerMinutes?: number;
  /** Total de copias en la oferta de lanzamiento */
  copiesTotal?: number;
  /** Copias ya reclamadas (escasez) */
  copiesClaimed?: number;
  /** Barra de compra fija en la parte inferior al hacer scroll */
  showStickyCta?: boolean;
};
export function App({
  offerMinutes = 15,
  copiesTotal = 500,
  copiesClaimed = 437,
  showStickyCta = true
}: AppProps) {
  return <SalesPage offerMinutes={offerMinutes} copiesTotal={copiesTotal} copiesClaimed={copiesClaimed} showStickyCta={showStickyCta} data-id="element-0" data-mp="2mn5b6i9dunh8" />;
}